enum ResourceDropOffModifierId {
    CUPELLATION = 'CUPELLATION',
    FOOD_IMPERIAL_OFFICIAL = 'FOOD_IMPERIAL_OFFICIAL',
    WOOD_IMPERIAL_OFFICIAL = 'WOOD_IMPERIAL_OFFICIAL',
    GOLD_IMPERIAL_OFFICIAL = 'GOLD_IMPERIAL_OFFICIAL',
    STONE_IMPERIAL_OFFICIAL = 'STONE_IMPERIAL_OFFICIAL',
    STEPPE_REDOUBT = 'STEPPE_REDOUBT',
    WOODEN_FORTRESS = 'WOODEN_FORTRESS',
    IMPROVED_PROCESSING = 'IMPROVED_PROCESSING',
    TUGHLAQ_ECO_0 = 'TUGHLAQ_ECO_0',
    TUGHLAQ_ECO_1 = 'TUGHLAQ_ECO_1',
    TUGHLAQ_ECO_2 = 'TUGHLAQ_ECO_2',
    TUGHLAQ_ECO_3 = 'TUGHLAQ_ECO_3',
}

export default ResourceDropOffModifierId;